import React, { useState, useMemo, useEffect } from "react";
import { IoClose } from "react-icons/io5";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { Input } from "formsy-react-components";

import { DayPickerRangeController } from "react-dates";
import { Row, Col } from "react-bootstrap";
import moment from "moment";
import { orderBy } from "lodash";

import { getWeekPeriod } from "../../utils";

import DropdownSearch from "../../../../common/DropdownSearch";

import * as departmentActions from "../../../../../actions/departmentActions";
import * as reportActions from "../../../../../actions/reportActions";

import ReportFilters from "../../../ReportFiltersComponent";

const DailyCallCompletionFilters = ({
  auth,
  onFiltersChange,
  departments,
  actions,
  loading,
  onFetchData,
  onPDFExport,
  exportDisabled
}) => {
  const [showDate, setShowDate] = useState(false);
  const [filters, setFilters] = useState({
    period: getWeekPeriod(new Date()),
    department: null
  });

  useEffect(() => {
    actions.loadDepartments();
  }, [actions]);

  useEffect(() => {
    onFiltersChange(filters);
  }, [filters, onFiltersChange]);

  const handleChangeDate = ({ startDate }) => {
    const newPeriod = getWeekPeriod(startDate.toDate());
    setFilters((prev) => ({ ...prev, period: newPeriod }));
  };

  const handleDepartmentChange = (name, data) => {
    setFilters((prev) => ({ ...prev, department: data.value }));
  };

  const handleFocus = () => {
    setShowDate(!showDate);
  };

  const handleResetFilters = () => {
    const newPeriod = getWeekPeriod(new Date());
    setFilters({ period: getWeekPeriod(new Date()), department: null });
    onFiltersChange({ period: newPeriod, department: null });
    actions.clearReport();
  };

  const departmentOptions = useMemo(() => {
    const options = departments.map((dep) => ({
      value: dep._id,
      label: dep.description
    }));
    return orderBy(options, [(option) => option.label.toLowerCase()]);
  }, [departments]);

  return (
    <ReportFilters
      onFetchClick={onFetchData}
      onResetClick={handleResetFilters}
      title={`Open Calls from ${filters.period.formattedStartDate} to ${filters.period.formattedEndDate}`}
      loading={loading}
      csvExportAvailable={false}
      pdfExportAvailable
      onPDFExport={onPDFExport}
      exportDisabled={exportDisabled}
    >
      <Row>
        <Col md={3}>
          <Input
            label="Date Range"
            name="period"
            value={`${filters.period.formattedStartDate} - ${filters.period.formattedEndDate}`}
            onFocus={handleFocus}
            addonBefore={
              <span
                className="glyphicon glyphicon-calendar"
                role="presentation"
                onKeyDown={() => {}}
                onClick={handleFocus}
              />
            }
          />
          {showDate && (
            <React.Fragment>
              <IoClose
                style={{
                  position: "absolute",
                  right: "5px",
                  top: "5px",
                  zIndex: "99999",
                  color: auth?.isNightMode ? "white" : "black"
                }}
                onClick={handleFocus}
              />
              <DayPickerRangeController
                startDate={moment(filters.period.startDate)}
                endDate={moment(filters.period.endDate)}
                numberOfMonths={1}
                focusedInput="startDate"
                enableOutsideDays
                keepOpenOnDateSelect={false}
                onDatesChange={handleChangeDate}
                onFocusChange={handleFocus}
              />
            </React.Fragment>
          )}
        </Col>
        <Col md={3} style={{ marginTop: 8 }}>
          <DropdownSearch
            rowStyles={{ marginTop: 2 }}
            rowClassNames=""
            placeholder="Select"
            label="Department"
            name="department"
            onChange={handleDepartmentChange}
            value={filters.department}
            data={departmentOptions}
            styles={{
              control: (baseStyles) => ({
                ...baseStyles,
                height: 42
              })
            }}
          />
        </Col>
      </Row>
    </ReportFilters>
  );
};

DailyCallCompletionFilters.propTypes = {
  auth: PropTypes.object,
  onFiltersChange: PropTypes.func,
  departments: PropTypes.array,
  actions: PropTypes.object,
  loading: PropTypes.bool,
  onFetchData: PropTypes,
  onPDFExport: PropTypes.func,
  exportDisabled: PropTypes.bool
};

function mapStatesToProps(state) {
  return {
    auth: state.reducers.auth,
    departments: state.reducers.departments,
    loading: state.reducers.loading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...departmentActions,
        ...reportActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(DailyCallCompletionFilters);
